function e(e, i, t, o) {
  for (; i >= t && !e("(min-resolution: " + i / o + "dppx)").matches;) i--;
  return i;
}
function i(i) {
  if (void 0 === i && (i = window), !i) return 1;
  if (void 0 !== i.devicePixelRatio) return i.devicePixelRatio;
  var t = i.document.frames;
  return void 0 !== t ? void 0 !== t.devicePixelRatio ? t.devicePixelRatio : t.screen.deviceXDPI / t.screen.systemXDPI : void 0 !== i.matchMedia ? function (i) {
    for (var t = i.matchMedia, o = 10, n = .1, r = 1, a = o, c = 0; c < 4; c++) o = (a = 10 * e(t, o, n, r)) + 9, n = a, r *= 10;
    return a / r;
  }(i) : 1;
}
function t(e, t) {
  var o = (e instanceof Element ? getComputedStyle(e).zoom : e.zoom) || 1;
  return i(t) * ("string" == typeof o ? parseFloat(o) : o);
}
export { t as elementZoomLevel, i as zoomLevel };